import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { notification, Select } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openNotificationWithIcon } from "../../../../libs/utils";
import { getReasons, updatedDetail } from "../../../../store/actions/precog";

const Option = Select.Option;

const SelectReasonsForm = ({newDetail, setLastUpdate, setNewDetail, setReason}) => {
  const dispatch = useDispatch();
  const reasons = useSelector(state => state.precog.reasons.data);

  useEffect(() => {
    dispatch(getReasons());
  }, []);

  const optionsList = [];
  if (reasons){
    reasons.map(el => {
      optionsList.push(<Option key={el.code} value={el.code}>
        {`${el.description}`}
      </Option>);
      return optionsList;
    });
  }

  const updateInAutoSave = (value) => {              
    notification.destroy();
    const updatedDetailObj = {reasonId: value};  

    dispatch(updatedDetail(newDetail?.id, updatedDetailObj)).then(() => {     
      setNewDetail( {...newDetail, ...updatedDetailObj});
      setLastUpdate(moment());
    }).catch(err => {     
      openNotificationWithIcon(
        notification,
        "error",
        "",
        err,
        null,
        null
      );
    });
  };

  return (
    <div style={{margin: "0 32px"}}>
      <div style={{color: "var(--brand-primary-shade-dark)", fontFamily: "Cairo", fontSize: "24px", fontWeight: 600}}>
            Seleziona la causale
      </div>
      <div style={{fontSize: "16px", lineHeight: "24px", color: "var(--text-01)", fontWeight: "normal"}}> 
        La causale determina i dettagli che dovrai aggiungere. Scegli con cura!
      </div>
      <div style={{marginTop: "32px", width: "537px"}} id="selectReasonsForm">
        <div>
          <b>Seleziona la causale</b>
        </div>
        <Select
          suffixIcon={
            <Button
              kind="primary" 
              size="medium" 
              style={{width: "40px", height: "40px"}}
              onClick={() => 
                dispatch(createAccountingYearsList(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))).then(res => {
                  navigate("/accounting-years-list");
                })
              }
            >
              <FontAwesomeIcon icon={["far", "arrow-right"]} style={{color: "#FFF"}} />
            </Button>
          }
          style={{paddingRight: 0}}
          showSearch
          optionFilterProp="children"
          getPopupContainer={trigger => trigger.parentNode}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          className={"pre-cog-select"}
          placeholder={"Seleziona una causale"}
          /* style={{border: errors?.reasonId ? "1px solid #d82829" : "none"}}*/          
          onSelect={value => {
          /** Serve tutto obj in caso di sezionale altrimenti si rompe la selezione sezionale */                      
            updateInAutoSave(value);
            setReason(value);
            
          }}
        >
          {optionsList}
        </Select>
      </div>

    </div>
  );
};

export default SelectReasonsForm;